module.exports = __webpack_public_path__ + "img/lahnstein.dcbf7920.jpg";